import { render, staticRenderFns } from "./PrintFormat.vue?vue&type=template&id=72a5ff47&"
import script from "./PrintFormat.vue?vue&type=script&lang=ts&"
export * from "./PrintFormat.vue?vue&type=script&lang=ts&"
import style0 from "./PrintFormat.vue?vue&type=style&index=0&id=72a5ff47&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports